import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { CustomImageHandler } from '../../../../shared/components/CustomImageHandler';
import { User } from '../../../../model/user/User';
import { useTranslation } from 'react-i18next';
import { UserRoles } from '../../../../enum/UserRoles';

interface IManagingUsersProps {
    users: User[];
    title: string;
}
const ManagingUsers = ({ users, title }: IManagingUsersProps) => {
    const { t } = useTranslation();

    return (
        <div className="mt-3 border-top border-light pt-2 mb-4">
            {users?.length >= 1 && <h6 className="mb-1 text-muted">{t(title)}</h6>}
            <Row>
                {users.map((user, i) => (
                    <Col lg={4} className="col-6 my-1" key={user.id}>
                        <div className="d-flex align-items-start" key={i}>
                            <div className="position-relative pr-2">
                                <CustomImageHandler
                                    photoPath={user.profilePhoto?.thumbnail ?? ''}
                                    thumbnailPath={user.profilePhoto?.thumbnail ?? ''}
                                    classes="user-img-rounded"
                                    altTag="User logo"
                                    name={user?.firstName}
                                />
                                {user?.userType === UserRoles.BRAND_MASTER && (
                                    <div
                                        className="position-absolute bg-primary upload-icon"
                                        style={{ width: 20, height: 20, top: -6, right: 0 }}
                                    >
                                        <i className="text-white fi fi-rr-crown" style={{ height: 15 }}></i>
                                    </div>
                                )}
                            </div>
                            <div className="d-flex flex-column ml-1">
                                <h6 className="mb-0">
                                    {user?.firstName} {user?.lastName}
                                </h6>
                                <span className="text-primary">
                                    {user?.position
                                        ? t(`general.positions.${user?.position}`)
                                        : user?.userType === UserRoles.BRAND_MASTER
                                        ? 'Admin'
                                        : '-'}
                                </span>
                                <p className="mb-1 mr-3">
                                    <i className="fi fi-rr-phone-call text-primary mr-1"></i>
                                    {user?.contact?.phone ?? '-'}
                                </p>
                                <p className="mb-1">
                                    <i className="fi fi-rr-envelope text-primary mr-1"></i>
                                    {user?.email ?? '-'}
                                </p>
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default ManagingUsers;
